export default "__VITE_ASSET__DuRPNz0H__"